import { InjectionToken } from '@angular/core';
import { Config } from './config';

export const CONFIG = new InjectionToken<Config>('Config');
